import './AuthType.scss'
import React, { useState, useCallback } from 'react'
import SwipeableViews from 'react-swipeable-views'
import { useTheme, useMediaQuery } from '@material-ui/core'
import { ButtonArrow } from '@svort/component'

import { Translated } from '../../utils/translated'
import { isSafariBrowser } from '../../utils/utils'
import reg2 from './images/reg2.png'
import reg3 from './images/reg3.png'

const AuthType = (props) => {

    const theme = useTheme();

    const [page, setPage] = useState(0);
    const [hover, setHover] = useState(false);

    const isMobile = useMediaQuery('(max-width:600px)');
    const isSafari = isSafariBrowser();

    const next = useCallback((isSecure) => {
        const route = isSecure
            ? props.isOnboarding
                ? '/onboarding-dots-maze'
                : '/auth-dots-maze'
            : props.isOnboarding
                ? '/onboarding-scale-emotions'
                : '/auth-scale-emotions';

        props.history.push('init-action', { route });
    }, [props.history, props.isOnboarding]);

    const types = [
        (<div key={0} className='zoomable'>
            <div className='auth-type-option'
                onMouseEnter={() => !isMobile && setHover(2)}
                onMouseLeave={() => !isMobile && setHover(false)}
                onClick={() => !isMobile && next(false)}>

                <div className='image'>
                    <img src={reg3} alt='loading...' />
                </div>
                <p><Translated id='app.auth-type.scale-emotions' /></p>
                <p><Translated id='app.auth-type.scale-emotions-desc' /></p>

                <ButtonArrow
                    text={<Translated id='app.auth-type.select' />}
                    isHover={hover === 2}
                    onClick={() => isMobile && next(false)} />
            </div>
        </div>),
        (<div key={1} className='zoomable'>
            <div className='auth-type-option'
                onMouseEnter={() => !isMobile && setHover(1)}
                onMouseLeave={() => !isMobile && setHover(false)}
                onClick={() => !isMobile && next(true)}>

                <div className='image'>
                    <img src={reg2} alt='loading...' />
                </div>
                <p><Translated id='app.auth-type.dots-maze' /></p>
                <p><Translated id='app.auth-type.dots-maze-desc' /></p>

                <ButtonArrow
                    text={<Translated id='app.auth-type.select' />}
                    isHover={hover === 1}
                    onClick={() => isMobile && next(true)} />
            </div>
        </div>)];

    return (
        <div className='auth-type'>
            <p className='auth-type-header'>{<Translated id={props.isOnboarding ? 'app.auth-type.title-onboarding' : 'app.auth-type.title-auth'} />}</p>

            {!isMobile
                ? <div className={`auth-type-options${!isSafari ? ' zoom' : ''}`}>
                    {types.map(x => x)}
                </div>
                : <SwipeableViews
                    className='auth-type-options'
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={page}
                    onChangeIndex={(step) => setPage(step)}
                    enableMouseEvents>
                    {types}
                </SwipeableViews>}

            <div className='pagination'>
                <div onClick={() => setPage(0)} style={{ opacity: page === 0 ? 1 : 0.3 }}></div>
                <div onClick={() => setPage(1)} style={{ opacity: page === 1 ? 1 : 0.3 }}></div>
            </div>
        </div>
    )
}

export default AuthType
